import type * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1:状态徽标单一枚举(收编 4 套 tone:loop Pill/runtime/pipeline/rule-surface + m07 硬编码)。
 * 形态=rounded-full(Intercom);色一律走 token。 */
export type BadgeTone = "success" | "warning" | "danger" | "info" | "muted" | "accent" | "neutral";

const TONE_CLASS: Record<BadgeTone, string> = {
	success: "bg-brand-success/10 text-brand-success",
	warning: "bg-brand-warning/10 text-brand-warning",
	danger: "bg-brand-danger/10 text-brand-danger",
	info: "bg-brand-info/10 text-brand-info",
	muted: "bg-surface-muted text-text-secondary",
	accent: "bg-brand-accent/10 text-brand-accent",
	neutral: "bg-surface-subtle text-text-secondary",
};

export function Badge({
	tone = "muted",
	className,
	children,
}: {
	tone?: BadgeTone;
	className?: string;
	children: React.ReactNode;
}) {
	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
				TONE_CLASS[tone],
				className,
			)}
		>
			{children}
		</span>
	);
}
